import { Component, EventEmitter, Input, OnChanges, Output, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';

import { KardexAuditProxyService } from '../../../proxies/inventory/kardex-audit.proxy.service';
import { KardexRollTransaction } from '../../../models/kardex-audit/kardex-audit';

@Component({
  selector: 'app-kardex-roll-history-dialog',
  templateUrl: './kardex-roll-history-dialog.component.html',
  styleUrls: ['./kardex-roll-history-dialog.component.scss'],
})
export class KardexRollHistoryDialogComponent implements OnChanges {
  private readonly proxyService = inject(KardexAuditProxyService);

  @Input({ required: true }) rollNumber!: string;
  @Input() highlightTransactionId: string | null = null;
  @Input() visible = false;
  @Output() closed = new EventEmitter<void>();

  isLoading = signal(false);
  transactions = signal<KardexRollTransaction[]>([]);

  ngOnChanges(): void {
    if (this.visible && this.rollNumber) {
      this.loadHistory();
    }
  }

  private loadHistory(): void {
    this.isLoading.set(true);
    this.proxyService
      .getRollHistory(this.rollNumber)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (result) => {
          this.transactions.set(result?.data?.transactions || []);
        },
        error: () => {
          this.transactions.set([]);
        },
      });
  }

  onVisibleChange(value: boolean): void {
    if (!value) {
      this.closed.emit();
    }
  }

  shortId(id: string): string {
    return id?.length > 6 ? id.slice(-6) : id;
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text);
  }
}
